import { useSelector } from "react-redux";
import { RootState } from "@/redux/store";
import { useQuery } from "@tanstack/react-query";
import { getPositionsWithChangeRequestsStatus } from "@/Washouts/api/WashoutReview/queries";

interface IUsePositionsWithChangeRequestsArgs {
	commissionCycleId?: string;
	payPeriodId: string;
}

export const usePositionsWithChangeRequests = (args: Readonly<IUsePositionsWithChangeRequestsArgs>) => {
	const { commissionCycleId, payPeriodId } = args;

	const location = useSelector((state: RootState) => state.location.location);
	const locationId = location?.locationId ?? "";

	const { data: positionsWithChangeRequests, isLoading } = useQuery({
		queryKey: ["positionsWithChangeRequestsStatus", locationId, commissionCycleId, payPeriodId],
		queryFn: async () => {
			const response = await getPositionsWithChangeRequestsStatus({
				locationId,
				commissionCycleId,
				payPeriodId,
			});
			return response?.positions;
		},
		staleTime: Infinity,
		enabled: !!locationId && !!payPeriodId,
	});

	const disabledByChangeRequests = positionsWithChangeRequests
		?.filter((position) => position.pendingRequestIds.length)
		.map((position) => position.position);

	return {
		isLoading,
		positionsWithChangeRequests,
		disabledByChangeRequests,
	};
};
